import { BookMarkedIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

/** "Retrieved n sources" under a knowledge-base or model answer. */
export const RetrievedSources = ({ count }: { count: number }) => {
  const { t } = useTranslation();

  if (count <= 0) {
    return null;
  }

  return (
    <span className="flex items-center gap-1.5 text-xs leading-4 font-medium text-foreground-muted">
      <BookMarkedIcon size={16} className="shrink-0" />
      {t('try_it.retrieved_sources', { count })}
    </span>
  );
};
